import { SHOP_DOMAIN } from './constants'
export enum ShopCode {
  FIV = 'FIV',
  SIP = 'SIP',
  SIB = 'SIB',
  SUN = 'SUN',
  SRP = 'SRP',
  LUK = 'LUK',
  CHE = 'CHE'
}

export const getShopCode = (): ShopCode => {
  const domain = SHOP_DOMAIN || ''
  if (domain.includes('sunflowerful')) return ShopCode.FIV
  if (domain.includes('silveryprinting')) return ShopCode.SIP
  if (domain.includes('fiverprints')) return ShopCode.SIB
  if (domain.includes('sunfloweric')) return ShopCode.SUN
  if (domain.includes('pinparadise1')) return ShopCode.SRP
  if (domain.includes('lukaprints')) return ShopCode.LUK
  if (domain.includes('sweetxmasgifts')) return ShopCode.CHE
  return ShopCode.FIV
}

export const getShopName = (): string => {
  const shopCode = getShopCode()
  switch (shopCode) {
    case ShopCode.SIP:
      return 'silveryprints'
    case ShopCode.FIV:
      return 'fiverprints'
    case ShopCode.SUN:
      return 'sunflowerly'
    case ShopCode.SIB:
      return 'silverybrand'
    default:
      return 'sunflowerly'
  }
}
